import React from "react";

const Footer = () => {
  return (
    <div className="content-container show">
      <div className="footer">© 2024 HIDEY</div>
    </div>
  );
};

export default Footer;
